import { Chip, CircularProgress, Tooltip } from "@mui/material";
import { CheckCircleOutline } from "@mui/icons-material";

interface Props {
  pending: boolean;
  accepted: boolean;
  size?: "small" | "medium";
}

/**
 * Capsule tag shown alongside the other status chips while changes are
 * waiting to be synced to a device or component. Shows a small loading
 * circle while pending and a checkmark once the change is accepted.
 * Derive the flags with usePendingChanges.
 */
export default function PendingChangesChip(props: Props) {
  const { pending, accepted, size } = props;

  if (pending) {
    return (
      <Tooltip title="Your most recent changes will be synced to the device as soon as possible">
        <Chip
          variant="outlined"
          label="Pending changes"
          icon={<CircularProgress size={14} thickness={5} color="inherit" />}
          size={size}
        />
      </Tooltip>
    );
  }

  if (accepted) {
    return (
      <Tooltip title="The device has accepted your most recent changes">
        <Chip
          variant="outlined"
          label="Settings synced"
          icon={<CheckCircleOutline style={{ color: "var(--status-ok)" }} />}
          size={size}
        />
      </Tooltip>
    );
  }

  return null;
}
